module.exports = __webpack_public_path__ + "img/50x50_gri.c94084d8.gif";